import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main: "#146ED2",
        },
        secondary: {
            main: "#3f51b5",
        },
    },
    breakpoints: {
        values: {
            xs:0,
            sm: 600,
            md:900,
            lg: 1200,
            xl: 1536,
        }
    }

});

export default theme;
